/**
 * Actionable insights produced by the reporting insight crawler (client-side over enriched transactions).
 */
export type InsightSeverity = "positive" | "warning" | "neutral";

export interface ActionableInsight {
  id: string;
  title: string;
  summary: string;
  /** Concrete steps the user can take */
  actions: string[];
  severity: InsightSeverity;
  /** Optional breakdown for UI (e.g. dimension + metrics) */
  meta?: Record<string, string | number>;
}

export type InsightCrawlerFrequency = "off" | "daily" | "weekly" | "monthly";

/** @deprecated Use AutomatedReportJob with type "insights" instead. Kept for legacy preference reads. */
export interface InsightCrawlerConfig {
  enabled: boolean;
  frequency: InsightCrawlerFrequency;
  /** ISO timestamp of last automated email (set by server cron or client "test send") */
  lastAutomatedRunAt?: string;
}

export type AutomatedReportFrequency = "off" | "daily" | "weekly" | "monthly";

export type AutomatedReportType = "insights" | "dashboard";

export interface AutomatedReportJob {
  id: string;
  type: AutomatedReportType;
  enabled: boolean;
  frequency: AutomatedReportFrequency;
  /** When type === "dashboard" */
  dashboardId?: string;
  /** ISO */
  lastSentAt?: string;
}

/** @deprecated Legacy cron preference key; new schedules use AUTOMATED_REPORTS_PREF_KEY only. */
export const INSIGHT_CRAWLER_PREF_KEY = "insight_crawler_config";
export const AUTOMATED_REPORTS_PREF_KEY = "automated_reports_config";

/** Payload for building insight digest PDFs (shared with export service). */
export interface InsightPdfItem {
  title: string;
  summary: string;
  actions: string[];
}
